import Vue from 'vue';
import App from './App.vue';
import store from './store.js';

/* VueTypedJs */
import VueTypedJs from 'vue-typed-js';
Vue.use(VueTypedJs);

Vue.config.productionTip = false;

new Vue(
  Vue.util.extend({ store }, App)
).$mount('#app');
